<template>
  <div class="materials-page">
    <h2 class="section-title">3D Printing Materials</h2>

    <div class="tags-container">
      <button v-for="(mat, index) in materials" :key="index" class="tag-btn" :class="{ active: currentIndex === index }"
        @click="switchMaterial(index)">
        {{ mat.name }}
      </button>
    </div>

    <div class="material-content">
      <div class="text-side">
        <h3 class="material-name">{{ materials[currentIndex].name }}</h3>
        <p class="material-desc">{{ materials[currentIndex].desc }}</p>

        <div class="detail-item" v-if="materials[currentIndex].Price">
          <span class="detail-label">Price:</span>
          <span class="detail-value">{{ materials[currentIndex].Price }}</span>
        </div>
        <div class="detail-item" v-if="materials[currentIndex].leadTime">
          <span class="detail-label">Lead Time:</span>
          <span class="detail-value">{{ materials[currentIndex].leadTime }}</span>
        </div>
        <div class="detail-item" v-if="materials[currentIndex].WallThickness">
          <span class="detail-label">Wall Thickness:</span>
          <span class="detail-value">{{ materials[currentIndex].WallThickness }}</span>
        </div>
        <div class="detail-item" v-if="materials[currentIndex].Tolerances">
          <span class="detail-label">Tolerances:</span>
          <span class="detail-value">{{ materials[currentIndex].Tolerances }}</span>
        </div>
        <div class="detail-item" v-if="materials[currentIndex].Maxpartsize">
          <span class="detail-label">Max part size:</span>
          <span class="detail-value">{{ materials[currentIndex].Maxpartsize }}</span>
        </div>

      </div>

      <div class="image-side">
        <img :src="materials[currentIndex].img" alt="Material sample" />
      </div>
    </div>

    <p class="footer-note">
      *For materials not shown here,
      <span class="contact-link" @click="$router.push('/contact')">please contact us directly.</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'printing_Materials',
  data() {
    return {
      currentIndex: 0,
      materials: [
        {
          name: 'Aluminum',
          desc: 'Aluminum is a highly ductile metal, making it easy to machine. The material has a good strength-to-weight ratio and is available in many types for a range of applications.',
          Price: '$',
          leadTime: '< 10 days',
          Tolerances: ':±0.2mm (±0.007″)',
          Maxpartsize: ' 400 x 400 x 350 mm',
          img:  require('@/assets/product/3d/111.jpg'),
        },
        {
          name: 'Copper',
          desc: 'Copper displays excellent thermal conductivity, electrical conductivity and plasticity. It is also highly ductile, corrosion resistant and can be easily welded.',
          Price: '$',
          leadTime: '< 10 days',
          Tolerances: ':±0.2mm (±0.007″)',
          Maxpartsize: ' 400 x 400 x 350 mm',
            img:  require('@/assets/product/3d/222.png'),
        },
        {
          name: 'Brass',
          desc: 'Brass has desirable properties for a number of applications. It is low friction, has excellent electrical conductivity and has a golden (brass) appearance.',
          Price: '$',
          leadTime: '< 10 days',
          Tolerances: ':±0.2mm (±0.007″)',
          Maxpartsize: ' 400 x 400 x 350 mm',
           img:  require('@/assets/product/3d/444.png'),
        },
        {
          name: 'Stainless Steel',
          desc: 'Stainless steel is the low carbon steel that offers many properties that are sought after for industrial applications. Stainless steel typically contains a minimum of 10% chromium by weight.',
          Price: '$',
          leadTime: '< 10 days',
          Tolerances: ':±0.2mm (±0.007″)',
          Maxpartsize: ' 400 x 400 x 350 mm',
         img:  require('@/assets/product/3d/555.png'),
        },
        {
          name: 'Titanium',
          desc: 'Titanium has a number of material properties that make it the ideal metal for demanding applications. These properties include excellent resistance to corrosion, chemicals and extreme temperatures. The metal also has an excellent strength-to-weight ratio.',
          Price: '$',
          leadTime: '< 10 days',
          Tolerances: ':±0.2mm (±0.007″)',
          Maxpartsize: ' 400 x 400 x 350 mm',
           img:  require('@/assets/product/3d/666.png'),
        },
        {
          name: 'PLA',
          desc: 'PLA (Polylactic Acid) is biodegradable, easy to print, commonly used for prototypes.',
          Price: '$',
          leadTime: '< 10 days',
          Tolerances: ':±0.2mm (±0.007″)',
          Maxpartsize: '800 x 800 x 550 cm',
           img:  require('@/assets/product/3d/777.png'),
        },
        {
          name: 'TPU',
          desc: 'TPU(Thermoplastic Polyurethane) is flexible and elastic, used for producing parts like seals or gaskets.',
          Price: '$',
          leadTime: '< 10 days',
          Tolerances: ':±0.2mm (±0.007″)',
          Maxpartsize: '800 x 800 x 550 cm',
          img:  require('@/assets/product/3d/888.png'),
        },
        {
          name: 'ABS',
          desc: 'ABS(Acrylonitrile Butadiene Styrene) is tough and impact-resistant, ideal for functional parts.',
          Price: '$',
          leadTime: '< 10 days',
          Tolerances: ':±0.2mm (±0.007″)',
          Maxpartsize: '800 x 800 x 550 cm',
          img:  require('@/assets/product/3d/999.png'),
        },
        {
          name: 'Nylon',
          desc: 'Nylon is flexible, durable, and strong; used for functional prototypes and end-use parts.',
          Price: '$',
          leadTime: '< 10 days',
          Tolerances: ':±0.2mm (±0.007″)',
          Maxpartsize: '800 x 800 x 550 cm',
          img:  require('@/assets/product/3d/10.png'),
        },
        {
          name: 'Resin',
          desc: 'Different types of resins are used in SLA for producing high-precision parts with smooth finishes.',
          Price: '$',
          leadTime: '< 10 days',
          Tolerances: ':±0.2mm (±0.007″)',
          Maxpartsize: '800 x 800 x 550 cm',
           img:  require('@/assets/product/3d/11.png'),
        },
      ]
    }
  },
  methods: {
    switchMaterial(index) {
      this.currentIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.materials-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

.section-title {
  text-align: center;
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 30px;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-bottom: 30px;
}

.tag-btn {
  padding: 5px 14px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  color: #646363;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  font-weight: 600;

  &.active {
    background-color: #16bc9c;
    border-color: #16bc9c;
    color: #fff;
  }

  &:hover:not(.active) {
    border-color: #16bc9c;
    color: #16bc9c;
  }
}

.material-content {
  display: flex;
  border: 1px solid #e5e5e5;
  margin-bottom: 30px;

  .text-side {
    flex: 1;
    padding: 30px;
    border-right: 1px solid #e5e5e5;

    .material-name {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      margin-bottom: 16px;
    }

    .material-desc {
      color: #666;
      line-height: 1.6;
      margin-bottom: 20px;
    }

    .detail-item {
      margin-bottom: 12px;
      color: #666;

      .detail-label {
        font-weight: 600;
        color: #333;
        margin-right: 4px;
      }
    }
  }

  .image-side {
    flex: 1.6;
    background-color: #f9f9f9;
    display: flex;
    justify-content: center; 
    align-items: center;     
    img {
      width: 70%;
      object-fit: contain; 
    }
  }
}

.footer-note {
  text-align: left;
  color: #666;
  font-size: 16px;
  font-weight: 400;

  .contact-link {
    color: #16bc9c;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

/* 🔥 移动端响应式样式更新 */
@media (max-width: 768px) {
  .material-content {
    flex-direction: column;
    /* 1. 去除整体外边框 */
    border: none; 

    /* 2. 利用 order 改变显示顺序：让 image-side 显示在 text-side 前面 */
    .image-side {
      order: 1;
      padding: 20px 0;
      background-color: #f9f9f9; /* 保留一点底色区分图片，如果不需要可以改为 transparent */
      border-radius: 8px; /* 给图片容器加个圆角好看点 */
      margin-bottom: 20px; /* 和下方文字隔开一点 */
      
      img {
        width: 80%; /* 移动端图片稍微放大一点点 */
      }
    }

    .text-side {
      order: 2;
      /* 3. 去除内部原有的右、下边框 */
      border-right: none;
      border-bottom: none;
      /* 4. 移动端取消大内边距，让文字紧凑排版 */
      padding: 0; 
    }
  }
}
</style>